export default {"src":"/_next/static/media/icon-call-phone.43863e99.svg","height":66,"width":66,"blurWidth":0,"blurHeight":0};